import React, { Fragment } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DashboardButtons from "../../../views/dashboard/desposition/DashboardButtons";
import FloatingPanels from "../../../views/dashboard/desposition/FloatingPanels";

const Remarks = () => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Container className="my-4">
        <div className="mb-3">
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
          >
            ← Go Back
          </Button>
        </div>

        <DashboardButtons />
        <FloatingPanels />
      </Container>
    </Fragment>
  );
};

export default Remarks;
